import type { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { io } from 'socket.io-client';
import { resolveSocketOptions } from './utils';

export function getSocket(data: GetSocketOptions): Socket {
  return io(`${data.baseUrl}/${data.namespace}`, resolveSocketOptions({
    socketPath: data.socketPath,
    isDevEnv: data.isDevEnv,
    sessionId: data.sessionId,
  }));
}

type GetSocketOptions = {
  baseUrl: string;
  socketPath: string;
  isDevEnv: boolean;
  namespace: SocketNamespace;
  sessionId?: string;
};